import * as React from 'react'
import { lazy, Suspense } from 'react'
import styled from 'styled-components/macro'
import {
  Tooltip,
  IconButton as MuiIconButton,
  CircularProgress,
  Typography,
} from '@mui/material'
import { useUser } from '../../services/contexts/UserContext'
import LogoutIcon from '@mui/icons-material/Logout'
import { useNavigate } from 'react-router-dom'
import { getErrorResponse } from '../../services/utils/helpers'
const ErrorFeedback = lazy(() => import('../Feedback'))
const IconButton = styled(MuiIconButton)`
  svg {
    width: 20px;
    height: 20px;
    color: white;
  }
`
const HeaderUserName = styled(Typography)`
  color: white;
`
//this div is used to hold user name and logout icon and text
const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 228px;
  height: 40px;
  right: 50px;
  top: 30px;
`
const TextLogout = styled(Typography)`
  color: white;
  font-weight: bold;
`

function NavbarUserDropdown() {
  const [anchorMenu] = React.useState(null)
  const { operator } = useUser()
  const [loggingOut, setLoggingOut] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const navigate = useNavigate()
  const logout = async () => {
    try {
      setLoggingOut(true)
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      setLoggingOut(false)
      navigate('/login')
    } catch (error) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      setLoggingOut(false)
      navigate('/login')
    }
  }

  return (
    <React.Fragment>
      {loggingOut ? (
        <div>
          <CircularProgress size={20} sx={{ color: 'action.disabled' }} />
        </div>
      ) : (
        <StyledDiv>
          <HeaderUserName variant="h5">
            {operator?.name === null ? '' : operator?.name}
          </HeaderUserName>
          <IconButton
            data-testid="logout-button"
            aria-owns={Boolean(anchorMenu) ? 'menu-appbar' : undefined}
            aria-haspopup="true"
            onClick={logout}
            color="inherit"
            size="large"
          >
            <Tooltip title="Abmelden">
              <LogoutIcon />
            </Tooltip>
            <TextLogout variant="h5">Abmelden</TextLogout>
          </IconButton>
        </StyledDiv>
      )}

      <Suspense fallback={<div />}>
        <ErrorFeedback
          open={hasError}
          severity="warning"
          title={getErrorResponse('UNAUTHORIZED')?.title}
          message={getErrorResponse('UNAUTHORIZED')?.detail}
          handleClose={() => {
            setHasError(false)
          }}
        />
      </Suspense>
    </React.Fragment>
  )
}

export default NavbarUserDropdown
